import { useResolvedAccessLevel } from '../../components/PermissionsContainer';

/** The per-leg editing gate — Edit on this is what lets someone change a leg at all. */
export const LEG_EDITING_COMPONENT_ID = 'leg-editing';
/** The LC order-field gate, shared with Change Template and the Addl Info LC edits. */
export const ORDER_LC_FIELDS_COMPONENT_ID = 'order-lc-fields';

/**
 * May this user fan a leg LOCATION across a set of orders?
 *
 * BOTH grants at Edit, which is deliberately stricter than editing the same cell on
 * one pro (that asks only for `leg-editing`). Changing where one order goes is
 * dispatch work; changing where forty go is the LC deciding the shape of the week,
 * and the two grants together name the people who do both.
 *
 * Mirrored server-side in `_require_leg_location_access` — this hook decides whether
 * the checkbox is drawn, and the endpoint decides whether the write happens, so a
 * stale bundle cannot talk its way past the gate.
 */
export const useCanChangeAllLegLocation = (): boolean => {
  const legEditing = useResolvedAccessLevel(LEG_EDITING_COMPONENT_ID, false, true);
  const lcFields = useResolvedAccessLevel(ORDER_LC_FIELDS_COMPONENT_ID, false, true);
  return legEditing >= 2 && lcFields >= 2;
};
